import React from 'react';
import styled from 'styled-components';
import { ILessonCycleActivityFeedbackBase } from '../../../../models/FeedbackModel';
import FeedbackList from '../components/FeedbackList';
import { IRefIds } from '../../../../constants/refs';

export type IProps = {
  activity: ILessonCycleActivityFeedbackBase;
};

const FeedbackActivityReading: React.FC<IProps> = (props) => {
  return (
    <Wrapper>
      <span>{props.activity.title}</span>
      <FeedbackList
        feedback={props.activity.feedback}
        refId={IRefIds.reading}
        itemId={props.activity.id}
      />
    </Wrapper>
  );
};

export default FeedbackActivityReading;

const Wrapper = styled.div`
  flex-direction: column;
  background-color: #e1fffb;
  padding: 4px 2px;
  border-radius: 4px;
`;
